import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  useIsMobile,
} from '@design-system';
import {
  QuickPlanForm,
  useShortFormIntake,
  type QuickPlanFormValues,
} from '@/features/client-quick-plan';

interface QuickPlanDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  advisorId: string;
  onSubmitSuccess?: (data: ShortFormIntakeResponse) => void;
}

export function QuickPlanDialog({
  open,
  onOpenChange,
  advisorId,
  onSubmitSuccess,
}: QuickPlanDialogProps) {
  const isMobile = useIsMobile();
  const { submitQuickPlan, isPending } = useShortFormIntake({
    advisorId,
    onSuccess: onSubmitSuccess,
  });

  function handleSubmit(data: QuickPlanFormValues) {
    submitQuickPlan(data);
  }

  const title = 'New Case Quick Start';
  const description = 'Enter basic client info to create a plan instantly. No email invite needed.';

  if (!isMobile) {
    return (
      <Dialog
        open={open}
        onOpenChange={onOpenChange}
      >
        <DialogContent className="max-h-[90vh] max-w-lg overflow-y-auto">
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            <DialogDescription>{description}</DialogDescription>
          </DialogHeader>
          <QuickPlanForm
            onSubmit={handleSubmit}
            isSubmitting={isPending}
          />
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer
      open={open}
      onOpenChange={onOpenChange}
    >
      <DrawerContent className="max-h-[90vh] overflow-y-auto px-4 pb-6">
        <DrawerHeader className="text-left">
          <DrawerTitle>{title}</DrawerTitle>
          <DrawerDescription>{description}</DrawerDescription>
        </DrawerHeader>
        <QuickPlanForm
          onSubmit={handleSubmit}
          isSubmitting={isPending}
        />
      </DrawerContent>
    </Drawer>
  );
}
